import { PHONE_1, PHONE_2, PHONE_1_DISPLAY, PHONE_2_DISPLAY } from '../../../components/feature/TopBar';

const WA_LINK = `https://wa.me/90${PHONE_1}?text=${encodeURIComponent('Merhaba, profesyonel temizlik hizmeti için randevu almak istiyorum.')}`;
const LOGO = 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/1c2c476bf3b5fc883cb26c7a37ec5870.jpeg';

const serviceLinks = ['Koltuk Yıkama', 'Sandalye Yıkama', 'Yatak Yıkama', 'Petek Temizliği'];
const serviceIds = ['koltuk', 'sandalye', 'yatak', 'petek'];

export default function Footer() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(`#service-detail-${id}`);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-[#111111] pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO} alt="Logo" className="w-12 h-12 rounded-full object-cover object-top" />
              <span className="text-white font-extrabold text-lg leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Temizlik<span className="text-emerald-400"> Fırsatı</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              18 yıllık tecrübemizle İstanbul genelinde koltuk yıkama, yatak yıkama, sandalye yıkama ve petek temizliği hizmetleri sunuyoruz.
            </p>
            <div className="flex items-center gap-3">
              <a href={WA_LINK} target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#25D366] rounded-full transition-colors" title="WhatsApp">
                <i className="ri-whatsapp-line text-white text-base" />
              </a>
              <a href="https://www.instagram.com/temizlik.firsati/" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500 rounded-full transition-colors" title="Instagram">
                <i className="ri-instagram-line text-white text-base" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61559750281545" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#1877F2] rounded-full transition-colors" title="Facebook">
                <i className="ri-facebook-fill text-white text-base" />
              </a>
              <a href={`tel:${PHONE_1}`} className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-emerald-500 rounded-full transition-colors" title="Telefon">
                <i className="ri-phone-line text-white text-base" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-base mb-5">
              <a href="#services">Hizmetler</a>
            </h4>
            <div className="flex flex-col gap-3">
              {serviceLinks.map((s, i) => (
                <button key={s} onClick={() => handleScroll(serviceIds[i])} className="text-gray-400 hover:text-emerald-400 text-sm transition-colors text-left cursor-pointer whitespace-nowrap">
                  {s}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-base mb-5">İletişim</h4>
            <div className="flex flex-col gap-4">
              <a href={`tel:${PHONE_1}`} className="flex items-center gap-2 text-gray-300 hover:text-emerald-400 transition-colors font-semibold whitespace-nowrap">
                <span className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full flex-shrink-0">
                  <i className="ri-phone-fill text-emerald-400 text-sm" />
                </span>
                {PHONE_1_DISPLAY}
              </a>
              <a href={`tel:${PHONE_2}`} className="flex items-center gap-2 text-gray-300 hover:text-emerald-400 transition-colors font-semibold whitespace-nowrap">
                <span className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full flex-shrink-0">
                  <i className="ri-phone-fill text-emerald-400 text-sm" />
                </span>
                {PHONE_2_DISPLAY}
              </a>
              <div className="flex items-start gap-2 text-gray-400 text-sm">
                <span className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-emerald-400 text-sm" />
                </span>
                <span>Anadolu Yakası &amp; Avrupa Yakası,<br />İstanbul geneli hizmet</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs text-center sm:text-left">
            © {new Date().getFullYear()} Temizlik Fırsatı. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-1 bg-emerald-500/10 border border-emerald-500/20 px-3 py-1.5 rounded-full">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-medal-line text-emerald-400 text-xs" />
            </span>
            <span className="text-emerald-400 text-xs font-semibold">18 Yıllık Tecrübe</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
